import Vue from 'vue';
// WARNING: This method becomes inefficient with large dataset
// Use when the dataset is small (< 10,000 rows)

/**
 * use when data is an array of objects
 * @param {Array} headers - Array of objects with text and value properties
 * @param {Array} items - Array of objects with the data to export
 * @param {string} filename - Name of the file to export
 * @param {string} sheetName - Name of the sheet to export
 *
 * @example
 * const { exportExcel } = useExcelExport();
 *
 */
export function useExcelExport() {
  const state = Vue.observable({
    exporting: false,
  });

  const getNestedValue = (obj, path) => {
    return path.split('.').reduce((o, i) => o?.[i], obj);
  };

  const detectType = (value) => {
    if (value === null || value === undefined) return '';

    // Detect date
    if (value instanceof Date) {
      return value;
    }

    return value;
  };

  const autoWidth = (data) => {
    return data[0].map((_, colIndex) => {
      const maxLength = Math.max(
        ...data.map((row) => {
          const cell = row[colIndex];
          return cell ? cell.toString().length : 10;
        })
      );

      return { wch: maxLength + 2 };
    });
  };

  const exportExcel = async ({
    headers,
    items,
    filename = 'reporte.xlsx',
    sheetName = 'Reporte',
  }) => {
    state.exporting = true;
    await Vue.nextTick();

    const XLSX = await import('xlsx');

    if (!headers?.length || !items?.length) return;

    // Exclude columns with export: false
    const exportableHeaders = headers.filter((h) => h.exportable !== false);

    const columns = exportableHeaders.map((h) => h.text);

    const rows = items.map((item) =>
      exportableHeaders.map((h) => {
        const rawValue = h.value.includes('.')
          ? getNestedValue(item, h.value)
          : item[h.value];

        return detectType(rawValue);
      })
    );

    const data = [columns, ...rows];

    const worksheet = XLSX.utils.aoa_to_sheet(data);

    // Auto column width
    worksheet['!cols'] = autoWidth(data);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    XLSX.writeFile(workbook, filename);

    state.exporting = false;
  };

  return {
    exporting: state,
    exportExcel,
  };
}
